/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkEditResultResponseResultsInnerRejectedInner
 */
export interface BulkEditResultResponseResultsInnerRejectedInner {
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponseResultsInnerRejectedInner
     */
    recordingId: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponseResultsInnerRejectedInner
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof BulkEditResultResponseResultsInnerRejectedInner
     */
    message: string;
}

/**
 * Check if a given object implements the BulkEditResultResponseResultsInnerRejectedInner interface.
 */
export function instanceOfBulkEditResultResponseResultsInnerRejectedInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingId" in value;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function BulkEditResultResponseResultsInnerRejectedInnerFromJSON(json: any): BulkEditResultResponseResultsInnerRejectedInner {
    return BulkEditResultResponseResultsInnerRejectedInnerFromJSONTyped(json, false);
}

export function BulkEditResultResponseResultsInnerRejectedInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkEditResultResponseResultsInnerRejectedInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingId': json['recording_id'],
        'code': json['code'],
        'message': json['message'],
    };
}

export function BulkEditResultResponseResultsInnerRejectedInnerToJSON(value?: BulkEditResultResponseResultsInnerRejectedInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording_id': value.recordingId,
        'code': value.code,
        'message': value.message,
    };
}

